import { create } from "zustand";

interface SidebarStore {
  isOpen: boolean;
  actions: {
    showSidebar: (isShowHide?: boolean) => void;
    resetSidebar: () => void;
  };
}

const useSidebarStore = create<SidebarStore>((set) => ({
  isOpen: true,
  actions: {
    showSidebar: (isShowHide) =>
      set((state) => ({ isOpen: isShowHide ?? !state.isOpen })),
    resetSidebar: () => set({ isOpen: true }),
  },
}));

export const useSidebarActions = () =>
  useSidebarStore((state) => state.actions);
export const useSidebar = () => useSidebarStore((state) => state.isOpen);
